import { ActivityReviewPage } from "./review";

export const ActivityReview = (): JSX.Element => {
  return <ActivityReviewPage />;
};
